<template>
    <div class="content">
        <div class="header">环境监测数据</div>
        <div class="close" @click="$emit('cancel')"><CloseCircleOutlined /></div>
        <div class="container">
            <div class="box">
                <div class="icon"><img :src="icon0" alt=""></div>
                <div class="text">
                    <p>空气温度</p>
                    <p>{{ data.temp }}</p>
                </div>
            </div>
            <div class="box">
                <div class="icon"><img :src="icon1" alt=""></div>
                <div class="text">
                    <p>相对湿度</p>
                    <p>{{ data.hum }}</p>
                </div>
            </div>
            <div class="box">
                <div class="icon"><img :src="icon3" alt=""></div>
                <div class="text">
                    <p>二氧化碳</p>
                    <p style="font-size: 16px">{{ data.co2 }}</p>
                </div>
            </div>
            <div class="box">
                <div class="icon"><img :src="icon2" alt=""></div>
                <div class="text">
                    <p>太阳辐射</p>
                    <p style="font-size: 16px">{{ data.radia }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import { ref } from 'vue'
export default {
    name: "infoBox",
    setup() {
        const data = ref({})
        const icon0 = require('@/assets/img/greenhouse_temp.png')
        const icon1 = require('@/assets/img/greenhouse_hum.png')
        const icon2 = require('@/assets/img/greenhouse_radia.png')
        const icon3 = require('@/assets/img/greenhouse_co2.png')
        return {
            data,
            icon0,
            icon1,
            icon2,
            icon3,
        }
    },
    methods: {
        setData(data) {
            const res = {}
            for (const i in data) {
                if (data[i].equipmentName === '太阳辐射') {
                    res.radia = data[i].equipmentValue + data[i].equipmentUnit
                } else if (data[i].equipmentName === '相对湿度') {
                    res.hum = data[i].equipmentValue + data[i].equipmentUnit
                } else if (data[i].equipmentName === '空气温度') {
                    res.temp = data[i].equipmentValue + data[i].equipmentUnit
                } else if (data[i].equipmentName === '二氧化碳') {
                    res.co2 = data[i].equipmentValue + data[i].equipmentUnit
                }
            }
            this.data = res
        }
    },
    components: {
        CloseCircleOutlined
    }
}
</script>
<style scoped lang="stylus">
    .content {
        width 510px
        height 330px
        position fixed
        top 250px
        left calc(50% - 255px)
        z-index 1
        background-image url("../../../assets/img/infoBox_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        .header {
            width 100%
            height 57px
            line-height 57px
            padding-left 55px
            font-size 24px
            color #FFF
            font-family 'PangMenZhengDao'
        }
        .close {
            position absolute
            top 15px
            right 40px
            color #fff
            font-size 18px
            cursor pointer
        }
        .container {
            width 100%
            height 253px
            padding 11.5px 40px
            display flex
            flex-wrap wrap
            align-items center
            justify-content center
            .box {
                width 50%
                height 80px
                display flex
                .icon {
                    width 80px
                    height 80px
                    cursor pointer
                }
                .icon img {
                    width 100%
                    height 100%
                }
                .text {
                    width calc(100% - 80px)
                    heiight 80px
                    display flex
                    align-items center
                    justify-content center
                    flex-wrap wrap
                    cursor pointer
                }
                .text p {
                    width 100%
                    text-align center
                }
                .text p:first-child {
                    font-size 20px
                    color #FFF
                }
                .text p:last-child {
                    font-size 25px
                    color #3EF5FC
                }
            }
        }
    }
</style>